import Chart from "react-apexcharts";
import React, { useEffect, useState } from 'react'
import { dimessionDeepDive } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import generateChartImage from "./generateChartImage";
import Remark from "./Remark";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DimessionDeepDive = ({ selectedCompanyId, graphName }) => {
    const [responseBody, setResponseBody] = useState([]);
    const [loading, setLoading] = useState(false);
    const [remark, setRemark] = useState(""); // For remark text
    const [remarkId, setRemarkId] = useState(null); // For remarkId
    const [isAttempt, setIsAttempt] = useState("")

    const getDimenstionFutureData = async () => {
        setLoading(true);
        try {
            const response = await dimessionDeepDive(selectedCompanyId, graphName);
            if (response?.data?.responseCode === 200) {
                setResponseBody(response?.data?.responseBody || []);
                const remark = response?.data?.remark || "";
                const remarkId = response?.data?.remarkId || null;
                const isAttempt = response?.data?.isAttempt ?? 0;

                // Set remark and remarkId to state
                setRemark(remark);
                setRemarkId(remarkId);
                setIsAttempt(isAttempt)
            } else if (response?.data?.responseCode === 404) {
                setResponseBody([]);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedCompanyId) {
            getDimenstionFutureData();
        }
    }, [selectedCompanyId]);

    // Extract categories and data for the chart
    const categories = responseBody.map((dimension) => dimension.dimensionName);
    const series = [
        {
            name: "Initiating",
            data: responseBody.map((dimension) => dimension.initiatingValue),
            color: "#D42327",
        },
        {
            name: "Emerging",
            data: responseBody.map((dimension) => dimension.emergingValue),
            color: "#fd8000",
        },
        {
            name: "Performing",
            data: responseBody.map((dimension) => dimension.performingValue),
            color: "#ffbf01",
        },
        {
            name: "Advancing",
            data: responseBody.map((dimension) => dimension.advancingValue),
            color: "#dbc51a",
        },
        {
            name: "Leading",
            data: responseBody.map((dimension) => dimension.leadingValue),
            color: "#92d14e",
        },
    ];

    const options = {
        chart: {
            id: 'chart_explanation',
            type: "bar",
            height: 350,
            events: {
                mounted: () => {
                    setTimeout(() => {
                        generateChartImage('chart_explanation', 'chart_explanation', remark); // Call the updated function here
                    }, 100); // Delay in milliseconds (e.g., 100ms or adjust as necessary)
                },
            },
            stacked: true,
            stackType: "100%",
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "35%",
            },
        },
        stroke: {
            width: 0.2,
            colors: ["#fff"],
        },
        grid: {
            show: false,
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ["#000"],
                fontSize: "9px",
            },
        },
        yaxis: {
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        xaxis: {
            categories,
            labels: {
                show: true,
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + "%";
                },
            },
        },
        fill: {
            opacity: 1,
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
            onItemClick: {
                toggleDataSeries: false,
            },
        },
    };

    const exportToExcel = (data, fileName = "Dimension Deep Dives") => {
        if (!data || !Array.isArray(data)) return;
     
        const title = ["Dimension Deep Dives – (Distribution Chart Explanation)"];
        const headers = [
            "Dimension Name",
            "Initiating Value",
            "Emerging Value",
            "Performing Value",
            "Advancing Value",
            "Leading Value"
        ];

        const rows = data.map(dimension => [
            dimension.dimensionName,
            dimension.initiatingValue,
            dimension.emergingValue,
            dimension.performingValue,
            dimension.advancingValue,
            dimension.leadingValue
        ]);

        const worksheet = XLSX.utils.aoa_to_sheet([
            title,
            [],
            headers,
            ...rows
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Dimension Stats");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, fileName);
    };


    return (
        <>
            <div className="text-end">
                <button className="px-3 py-2 mb-3 text-white bg-primary rounded border-0 ms-2" onClick={() => exportToExcel(responseBody)}>Download Excel</button>

            </div>
            <div className="stackedChart_content">
                {loading ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : responseBody.length > 0 ? (
                    <div className="chart15" data-heading="Dimension Deep Dives – (Distribution Chart Explanation)" data-remark={remark}>
                        <Chart
                            options={options}
                            series={series}
                            type="bar"
                            width={600}
                        />
                    </div>
                ) : (
                    <div>No data available for the selected company.</div>
                )}
                <Remark selectedCompanyId={selectedCompanyId} graphName="DimensionDeepDives" initialRemark={remark}
                    remarkId={remarkId} isAttempt={isAttempt} setRemarkprops={setRemark} />

            </div>
        </>
    );
};

export default DimessionDeepDive;
